// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderCheckoutCharge,
    ProviderCheckoutChargeSortType,
    ProviderCheckoutPaymentPlanSortType,
    ProviderPaymentPlan,
    SupportCheckoutCharge,
    SupportCheckoutChargeSortType,
    SupportCheckoutPaymentPlanSortType,
    SupportPaymentPlan,
    ProviderCheckoutChargeFromJSON,
    ProviderPaymentPlanFromJSON,
    SupportCheckoutChargeFromJSON,
    SupportPaymentPlanFromJSON,
} from '../models';

export interface ListProviderCheckoutChargesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCheckoutChargesOrderEnum>;
    filterCreated?: Array<string>;
    filterGuarantorId?: Array<string>;
    sort?: Array<ProviderCheckoutChargeSortType>;
}

export interface ListProviderCheckoutPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCheckoutPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterInvoiceId?: Array<string>;
    sort?: Array<ProviderCheckoutPaymentPlanSortType>;
}

export interface ListSupportCheckoutChargesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCheckoutChargesOrderEnum>;
    filterCreated?: Array<string>;
    filterGuarantorId?: Array<string>;
    sort?: Array<SupportCheckoutChargeSortType>;
}

export interface ListSupportCheckoutPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCheckoutPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterInvoiceId?: Array<string>;
    sort?: Array<SupportCheckoutPaymentPlanSortType>;
}

/**
 * no description
 */
export class CheckoutApi extends runtime.BaseAPI {

    /**
     * Gets a list of checkout charges
     * Get a list of checkout charges
     */
    async listProviderCheckoutChargesRaw(requestParameters: ListProviderCheckoutChargesRequest): Promise<runtime.ApiResponse<Array<ProviderCheckoutCharge>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/checkout/charge`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCheckoutChargeFromJSON));
    }

    /**
     * Gets a list of checkout charges
     * Get a list of checkout charges
     */
    async listProviderCheckoutCharges(requestParameters: ListProviderCheckoutChargesRequest): Promise<Array<ProviderCheckoutCharge>> {
        const response = await this.listProviderCheckoutChargesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of checkout payment plans
     * Get a list of checkout payment plans
     */
    async listProviderCheckoutPaymentPlansRaw(requestParameters: ListProviderCheckoutPaymentPlansRequest): Promise<runtime.ApiResponse<Array<ProviderPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterInvoiceId) {
            queryParameters['filterInvoiceId'] = requestParameters.filterInvoiceId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/checkout/payment_plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPaymentPlanFromJSON));
    }

    /**
     * Gets a list of checkout payment plans
     * Get a list of checkout payment plans
     */
    async listProviderCheckoutPaymentPlans(requestParameters: ListProviderCheckoutPaymentPlansRequest): Promise<Array<ProviderPaymentPlan>> {
        const response = await this.listProviderCheckoutPaymentPlansRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of checkout charges
     * Get a list of checkout charges
     */
    async listSupportCheckoutChargesRaw(requestParameters: ListSupportCheckoutChargesRequest): Promise<runtime.ApiResponse<Array<SupportCheckoutCharge>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/checkout/charge`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCheckoutChargeFromJSON));
    }

    /**
     * Gets a list of checkout charges
     * Get a list of checkout charges
     */
    async listSupportCheckoutCharges(requestParameters: ListSupportCheckoutChargesRequest): Promise<Array<SupportCheckoutCharge>> {
        const response = await this.listSupportCheckoutChargesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of checkout payment plans
     * Get a list of checkout payment plans
     */
    async listSupportCheckoutPaymentPlansRaw(requestParameters: ListSupportCheckoutPaymentPlansRequest): Promise<runtime.ApiResponse<Array<SupportPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterInvoiceId) {
            queryParameters['filterInvoiceId'] = requestParameters.filterInvoiceId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/checkout/payment_plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPaymentPlanFromJSON));
    }

    /**
     * Gets a list of checkout payment plans
     * Get a list of checkout payment plans
     */
    async listSupportCheckoutPaymentPlans(requestParameters: ListSupportCheckoutPaymentPlansRequest): Promise<Array<SupportPaymentPlan>> {
        const response = await this.listSupportCheckoutPaymentPlansRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderCheckoutChargesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCheckoutPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCheckoutChargesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCheckoutPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
